<form (ngSubmit)="update()" autocomplete="off">
    <app-card headline="Edit User">
        <app-card-body>
            <div style="padding: 20px">
            <app-edit-user-inner [user]="user" (formIsValid)="formIsValid($event)" (formIsDirty)="innerFormIsDirty($event)"></app-edit-user-inner>
        </div>
        </app-card-body>
        <app-card-footer>
            <div class="btn-group float-right">
                <button class="btn btn-danger"
                        type="button"
                        *ngIf="showDeleteButton"
                        [disabled]="!isUserDeletable"
                        (click)="delete()">
                    Delete
                </button>
                <button class="btn btn-warning" type="button" (click)="passwordReset()">
                    Reset password
                </button>
                <button class="btn btn-success"
                        type="button"
                        *ngIf="showRestoreButton"
                        (click)="restore()">
                    Restore
                </button>
                <button class="btn btn-primary"
                        [disabled]="!inputValid">
                    Update
                </button>

                <button class="btn btn-outline-secondary" (click)="cancel()">
                    Cancel
                </button>
            </div>
        </app-card-footer>
    </app-card>
</form>
